module.exports = __webpack_public_path__ + "static/media/markprojectcompleted.f6ad368b.PNG";